import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TitleText = styled.label`
  text-align: start;
  font-size: ${(props) => props.theme.font.size.primary};
  font-weight: 600;
  color: ${(props) => props.theme.color.text.primary};
`;

const InfoWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: start;
`;

const InfoIcon = styled.img`
  height: ${(props) => props.theme.iconSize.large};
`;

const InfoText = styled.label`
  text-align: start;
  font-weight: 400;
  margin-left: 24px;
  font-size: ${(props) => props.theme.font.size.secondary};
  color: ${(props) => props.theme.color.text.primary};
`;

const DisclaimerText = styled.label`
  text-align: start;
  font-weight: 400;
  margin-top: 24px;
  font-size: ${(props) => props.theme.font.size.secondary};
  color: ${(props) => props.theme.color.text.primary};
`;

const AccentText = styled.label`
  text-align: start;
  font-weight: 600;
  margin-top: 24px;
  font-size: ${(props) => props.theme.font.size.secondary};
  color: ${(props) => props.theme.color.accent};
`;

export { Container, TitleText, InfoWrapper, InfoText, InfoIcon, DisclaimerText, AccentText };
